import { apiSlice } from 'store/slices/api/api-slice';
import {
    CreateProductPriceRequest,
    ProductPriceResponse,
} from 'types/product/product-price';

export const creatProductPrice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        addProductPrice: builder.mutation<void, CreateProductPriceRequest>({
            query: (createProductPriceRequest: CreateProductPriceRequest) => ({
                url:
                    `/product/save-product-price/` +
                    createProductPriceRequest.productId,
                method: 'POST',
                body: createProductPriceRequest,
            }),
        }),

        updateProductPrice: builder.mutation<void, CreateProductPriceRequest>({
            query: (createProductPriceRequest: CreateProductPriceRequest) => ({
                url:
                    `/product/update-product-price/` +
                    createProductPriceRequest.productPriceId,
                method: 'PUT',
                body: createProductPriceRequest,
            }),
        }),

        priceList: builder.query<ProductPriceResponse[], string>({
            query: (params) => ({
                url: `/product/product-prices/` + params,
                method: 'GET',
            }),
        }),

        productPriceData: builder.query<ProductPriceResponse, string>({
            query: (params) => ({
                url: `/product/product-price/` + params,
                method: 'GET',
            }),
        }),

        priceDelete: builder.mutation<void, string>({
            query: (id: string) => ({
                url: `/product/delete-product-price/` + id,
                method: 'DELETE',
                header: {},
            }),
        }),
    }),
});

export const {
    useAddProductPriceMutation,
    useUpdateProductPriceMutation,
    useLazyPriceListQuery,
    usePriceDeleteMutation,
    useProductPriceDataQuery,
} = creatProductPrice;
